// @flow weak

export const ADD = '@notification/ADD';
export const REMOVE = '@notification/REMOVE';

export type OptionalNavigationAction = {
  '@notification/ADD'?: {
    message: string,
    level?: 'success' | 'error',
  },
};

export const addNotification = (message, level) => ({
  type: ADD,
  message,
  level,
});

export const removeNotification = id => ({
  type: REMOVE,
  id,
});



// WEBPACK FOOTER //
// ./src/actions/notification.js